import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { useAnalyticsCardLegend } from '../../../hooks/useAnalyticsCardLegend';
import { useAnalyticsParams } from '../../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { extractPrimitiveValue } from '../../../utils/extractPrimitiveValue';
import { getExternalSource } from '../../../utils/getExternalSource';
import { createAnalyticsChartData } from './utils/createAnalyticsChartData';
import { formatChartLabel } from './utils/formartChartLabel';
import { formatChartValue } from './utils/formatChartValue';
export const useAnalyticsReportCard = ({ reportData, columns, reportDefinition, activeSeries, setActiveSeries, headerOptions, isLoading, }) => {
    const { groupBy, dateRange } = useAnalyticsParams();
    const { toShopTime } = useShopTime();
    const activeColumn = columns.find((column) => column.id === activeSeries);
    const legend = useAnalyticsCardLegend();
    const timezonedDateRange = [
        toShopTime(dateRange.value.dates[0]),
        toShopTime(dateRange.value.dates[1]),
    ];
    const getSeriesSummaryValue = () => {
        if (!reportData ||
            !activeSeries ||
            !('summary' in reportData.report) ||
            !reportData.report.summary ||
            !(activeSeries in reportData.report.summary)) {
            return 0;
        }
        if (!activeColumn)
            return 0;
        const summaryValue = reportData.report.summary[activeSeries];
        const primitiveValue = extractPrimitiveValue(summaryValue);
        return typeof primitiveValue === 'number' ? primitiveValue : 0;
    };
    const getCardHeader = () => {
        if (!activeColumn) {
            return {
                label: 'Report',
            };
        }
        return {
            label: String(activeColumn.label) || '',
            tooltip: activeColumn.tooltip,
            options: headerOptions,
            onOptionSelect: setActiveSeries,
        };
    };
    return {
        isLoading,
        type: (reportDefinition?.graphType === 'bar' ? 'barChart' : 'lineChart'),
        data: createAnalyticsChartData({
            reportData,
            activeSeries: activeSeries || reportDefinition?.yAxisDefaultValue || '',
        }),
        emptyMessage: 'No data found in this date range',
        value: getSeriesSummaryValue(),
        header: getCardHeader(),
        legend,
        externalSource: getExternalSource(reportDefinition?.dataSource),
        formatValue: (value) => formatChartValue(value, activeColumn?.type),
        formatXAxis: (value) => formatChartLabel({
            value,
            type: columns[0].type,
            timezonedDateRange,
            precision: groupBy.value.value,
        }),
    };
};
